<template>
    <div class="course-background">
        Add a new course below
    </div>
  
</template>

<script>
export default {
    name: 'CourseCMS'
}
</script>

<style scoped>
    .course-background {
        background-color: #fff;
    }

</style>